export enum AppChannels {
  SHOPIFY = 'SHOPIFY',
  TUNEBOOM = 'TUNEBOOM',
}

/**
 * Canonical Shopify Admin API version used across REST + GraphQL clients,
 * the webhook TOML, and GraphQL codegen. Bump this in one place.
 */
export const SHOPIFY_API_VERSION = '2026-04';

export const NESTJS_SHOPIFY_OPTIONS = 'NESTJS_SHOPIFY_OPTIONS';

/**
 * Filenames (minus extension) of the blocks in `extensions/tuneboom-player/blocks`. Shopify
 * serializes a placed block or an enabled embed as
 * `shopify://apps/<app-handle>/blocks/<handle>/<extension-uuid>`, so each handle is both the
 * segment we match on when verifying and the value we put in the theme-editor deep link.
 */
export const THEME_PLAYER_BLOCK_HANDLE = 'player';
export const THEME_APP_EMBED_BLOCK_HANDLE = 'tuneboom';

// NOTE: theme-editor `activateAppId` deep links use `<app api key>/<handle>` — the api key is
// per-app (staging vs production), matching whichever app deployed the extension. The uid in
// shopify.extension.toml is NOT what Shopify keys activation on (theme entries carry a per-app
// registration uuid), so it must never be used in deep links.

export const ShopifyAppAssets = [
  {
    path: 'theme/templates/collection.tuneboom.playlist.liquid',
    target: 'templates/collection.tuneboom.playlist.liquid',
  },
  {
    path: 'theme/templates/product.tuneboom.album.liquid',
    target: 'templates/product.tuneboom.album.liquid',
  },
  {
    path: 'theme/templates/product.tuneboom.track.liquid',
    target: 'templates/product.tuneboom.track.liquid',
  },
  {
    path: 'theme/styles/tuneboom.scss.liquid',
    target: 'assets/tuneboom.scss.liquid',
  },
  {
    path: 'https://storage.googleapis.com/static.tuneboom.io/shopify/bootstrap.css',
    target: 'assets/bootstrap.css',
  },
  {
    path: 'theme/snippets/tuneboom-icon-facebook.liquid',
    target: 'snippets/tuneboom-icon-facebook.liquid',
  },
  {
    path: 'theme/snippets/tuneboom-icon-twitter.liquid',
    target: 'snippets/tuneboom-icon-twitter.liquid',
  },
  {
    path: 'theme/snippets/tuneboom-social-sharing.liquid',
    target: 'snippets/tuneboom-social-sharing.liquid',
  },
  {
    path: 'theme/snippets/tuneboom-player.liquid',
    target: 'snippets/tuneboom-player.liquid',
  },
  {
    path: 'theme/snippets/tuneboom-track.liquid',
    target: 'snippets/tuneboom-track.liquid',
  },
  {
    path: 'theme/snippets/tuneboom-track-list.liquid',
    target: 'snippets/tuneboom-track-list.liquid',
  },
  {
    path: 'theme/snippets/media-tuneboom.liquid',
    target: 'snippets/media-tuneboom.liquid',
  },
  {
    path: 'theme/snippets/product-price-tuneboom.liquid',
    target: 'snippets/product-price-tuneboom.liquid',
  },
  {
    path: 'theme/sections/collection-tuneboom-playlist.liquid',
    target: 'sections/collection-tuneboom-playlist.liquid',
  },
  {
    path: 'theme/sections/product-tuneboom-album.liquid',
    target: 'sections/product-tuneboom-album.liquid',
  },
  {
    path: 'theme/sections/product-tuneboom-track.liquid',
    target: 'sections/product-tuneboom-track.liquid',
  },
  {
    path: 'https://storage.googleapis.com/static.tuneboom.io/shopify/shopify-money.js',
    target: 'assets/shopify-money.js',
  },
  {
    path: 'https://storage.googleapis.com/static.tuneboom.io/shopify/wavesurfer.js',
    target: 'assets/wavesurfer.js',
  },
  {
    path: 'https://storage.googleapis.com/static.tuneboom.io/shopify/tuneboom.js',
    target: 'assets/tuneboom.js',
  },
];
